import { useToast } from 'primevue/usetoast';

export function useGlobalToast() {
    const toast = useToast();

    function showToast({ severity = 'contrast', summary = '', detail = 'Default Detail', life = 0 } = {}) {
        if(life === 0){
            toast.add({ severity, summary, detail});   
        }else{
            toast.add({ severity, summary, detail, life });
        }
        
    }


    return { showToast };
}